import script from "./ChatDetailHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDetailHeader.vue?vue&type=script&setup=true&lang=js"

import "./ChatDetailHeader.vue?vue&type=style&index=0&id=711387bb&lang=scss"

const __exports__ = script;

export default __exports__